import { useTranslation } from "react-i18next";
import "./style.scss";
import Button from "../button";
import { useIsDesktopOrTablet } from "./../../../../../hooks";
import { AudioRecorder } from "../audio-recorder";
import { BottomBar } from "../bottom-bar";

function PlayTriangle({
  direction = "right",
  size = 64,
  strokeWidth = 1.5,
}: {
  direction?: "left" | "right";
  size?: number;
  strokeWidth?: number;
}) {
  const transform =
    direction === "left" ? "scale(-1,1) translate(-24,0)" : undefined;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform={transform}>
        <polygon
          points="7,4 19,12 7,20"
          fill="none"
          stroke={"currentColor"}
          strokeWidth={strokeWidth}
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export function Footer({
  onPreviousClick,
  onNextClick,
  isPreviousDisabled = false,
  isMicrophoneDisabled = false,
  isNextDisabled = false,
  onAudioReady,
}: {
  onPreviousClick: () => void;
  onNextClick: () => void;
  isPreviousDisabled?: boolean;
  isMicrophoneDisabled?: boolean;
  isNextDisabled?: boolean;
  onAudioReady?: (audio: Blob) => Promise<void>;
}) {
  const { t } = useTranslation();
  const isDesktopOrTablet = useIsDesktopOrTablet();
  return (
    <footer className="tg_footer">
      <div className="controls tg_column">
        {!isDesktopOrTablet && (
          <button
            className={`control-btn ${isPreviousDisabled ? "disabled" : ""}`}
            onClick={onPreviousClick}
            disabled={isPreviousDisabled}
            aria-label="Previous"
          >
            <PlayTriangle direction="left" />
          </button>
        )}
        {isDesktopOrTablet && (
          <Button
            className={`navigation-btn ${isPreviousDisabled ? "disabled" : ""}`}
            onClick={onPreviousClick}
            disabled={isPreviousDisabled}
            previous
            navigation
          >
            {t("frontend.test.backTestSetButtonText", "Back")}
          </Button>
        )}
        <AudioRecorder
          disabled={isMicrophoneDisabled}
          onAudioReady={onAudioReady}
        />
        {!isDesktopOrTablet && (
          <button
            className={`control-btn ${isNextDisabled ? "disabled" : ""}`}
            onClick={onNextClick}
            disabled={isNextDisabled}
          >
            <PlayTriangle direction="right" />
          </button>
        )}
        {isDesktopOrTablet && (
          <Button
            className={`navigation-btn ${isNextDisabled ? "disabled" : ""}`}
            onClick={onNextClick}
            disabled={isNextDisabled}
            next
            navigation
          >
            {t("frontend.test.nextTestSetButtonText", "Next")}
          </Button>
        )}
      </div>
      {!isDesktopOrTablet && (
        <div>
          <BottomBar isWizard />
        </div>
      )}
    </footer>
  );
}
